import React from "react";
import Page from "src/components/Page";
import View from "./view";

function index(props) {
  localStorage.removeItem("@imageSingle");

  


  return (
  
    <Page >
      <View />
    </Page>
  
  );
}

export default index;
